import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {AddEditFormComponent} from "../add-edit-form/add-edit-form.component";
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl} from "@angular/forms";
import {UpdateDatatableService} from "../services/update-datatable-service";
import {JobalertComponent} from "../jobalert/jobalert.component";
import {EncryptDecryptService} from "../services/encrypt-decrypt.service";
import { VariablesGlobales } from '../services/globals';
import swal from "sweetalert2";
@Component({
  selector: 'app-edit-jobalert',
  templateUrl: './edit-jobalert.component.html',
  styleUrls: ['./edit-jobalert.component.css']
})
export class EditJobalertComponent implements AfterViewInit {

  recordId: number;

  jsonData: string;
  apikey: string;

  fonctionArray: string[];
  regionArray: string[];
  user: any;
  idFonctionArray: any[] = new Array();
  region: Region[] = [];
  emploiFonction: Fonction[] = [];
  posteContrat: Contrat[] = [];

  // This is a form group from FormBuilder.
  @ViewChild(AddEditFormComponent)
  addEditForm: AddEditFormComponent;

  jobAlertProp: JobalertComponent
  constructor(public param: VariablesGlobales, private encdec: EncryptDecryptService, private http: HttpClient, @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<EditJobalertComponent>, private updateDatatableService: UpdateDatatableService) { }

  ngAfterViewInit(): void {
    setTimeout(() => {
     this.getInfoJA();
    }, 200);
  }

  getInfoJA()
  {
    let resp: string = "";
    this.apikey = localStorage.getItem('apikey');
    this.http.get('https://api2.sitederecrutement.com/Home/getinfos?apikey='+this.apikey, { responseType: "text" }).subscribe(
      result => {
        this.jsonData = this.encdec.getDecrypt(result);
        let jsonObject: any = JSON.parse(this.jsonData);

        this.emploiFonction = jsonObject.fonctions;
        this.posteContrat = jsonObject.contrats;
        this.region = jsonObject.regions;

        let fonction = this.parseIdFonction(this.emploiFonction)
        let region1 = this.parseIdRegion(this.region)
        let regionTab = region1.map(function (value){
          return String(value);
        })
        let idTab = fonction.map(function (value){
          return String(value);
        })
        this.addEditForm.addEditJobForm.get('name').setValue(this.data.jobalert_nom);
        this.addEditForm.addEditJobForm.get('mail').setValue(this.data.jobalert_mail);
        this.addEditForm.addEditJobForm.get('fonctionName').setValue(idTab);
        this.addEditForm.addEditJobForm.get('regionName').setValue(regionTab);
        this.addEditForm.addEditJobForm.get('jobalert_portable').setValue(this.data.jobalert_portable);
      }
    )
  }

  parseIdFonction(data : any[])
  {
    let txtf = new Array();
    this.fonctionArray = this.data.jobalert_fonction.split(',');
    data.forEach(x => {
      this.fonctionArray
        .filter(e => e === x.fonction)
        .forEach(e => txtf.push(x.idfonction));
    });
    return txtf;
  }

  parseIdRegion(data : any[])
  {
    let txtf = new Array();
    this.regionArray = this.data.jobalert_region.split(',');
    data.forEach(x => {
      this.regionArray
        .filter(e => e === x.region)
        .forEach(e => txtf.push(x.idregion));
    });
    return txtf;
  }

  getFonctionName(rows) {
    let txtf = new Array();
    for(let id of rows)
    {
      txtf.push(this.emploiFonction.find(d => d.idfonction === Number(id)).fonction);
    }
    return txtf;
  }

  getregionName(rows) {
    let txtf = new Array();
    for(let id of rows)
    {
      txtf.push(this.region.find(d => d.idregion === Number(id)).region);
    }
    return txtf;
  }

  onUpdate(alertId: number){
    let jobName = this.addEditForm.addEditJobForm.get('name').value;
    let jobReg = this.addEditForm.addEditJobForm.get('regionName').value;
    let jobFctn = this.addEditForm.addEditJobForm.get('fonctionName').value;
    let mail = this.addEditForm.addEditJobForm.get('mail').value;
    this.user = JSON.parse(localStorage.getItem('currentUser'));

    //this.getFonctionName2(this.getFonctionName(jobFctn));
    let obj: JobAlert = {
      idcandidat_jobalert: alertId,
      idcandidat: this.user.idcandidat,
      jobalert_nom: jobName,
      jobalert_mail: mail,
      jobalert_fonction: this.getFonctionName(jobFctn).join(','),
      jobalert_region: this.getregionName(jobReg).join(','),
      jobalert_portable: this.addEditForm.addEditJobForm.get('jobalert_portable').value

    }
    //console.log(this.getFonctionName(jobFctn).join(','));
    // formattage data
    let data = this.encdec.getEncrypt( JSON.stringify(obj));
    const formData = new FormData();
    formData.append('datas', data);

    //envoi des données
    this.http.post('https://api2.sitederecrutement.com/Home/updatealerte?apikey=' + this.apikey, formData, {responseType: "text"}).subscribe(
      () => {
        this.dialogRef.close();
      },
      error => {
        console.log(error);
      }
    )
    swal.fire({
      title: "Modifiée",
      text: "Votre experience a bien été modifiée",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-rose",
      },
      icon: "success",
      iconColor: 'd '
    });
  }
/*

    console.log(this.recordId+' '+jobName);
    this.http.get('api/SampleData/UpdateJobAlert?idj='+this.recordId+'&nom='+jobName+'&con=,,'+jobCtr+',,&fon=,,'+jobFctn+',,').subscribe(
      () => {
          this.dialogRef.close();
        },
      error => {
          console.log(error);
      }
    )
  }*/
}

interface JobAlert{
  idcandidat_jobalert: number;
  idcandidat: string;
  jobalert_mail: string;
  jobalert_nom: string;
  jobalert_fonction: string;
  //jobalert_contrat: string;
  jobalert_region: string;
  jobalert_portable: string;
}

interface Region{
  idregion: number;
  region: string;
}

interface Contrat{
  idcontrat: number;
  contrat: string;
}

interface Fonction{
  idfonction: number;
  fonction: string;
}
